import LocalizedStrings from 'react-localization';
import en from './translations.en';

const strings = new LocalizedStrings({
  en,
});

export default strings;
